import styled from 'styled-components';

export const StyledMenuItemCompetition = styled.div`
    width: 100%;
    background-color: #d2e2ff;
    cursor: pointer;
    overflow: hidden;
    -moz-overflow: hidden;

    @media only screen and (max-width: 400px) {
        p {
            font-size: 12px;
        }
    }
`;
